var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"references"},[_c('div',{staticClass:"references__container"},[_c('div',{staticClass:"references__container__col"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.mainDesc)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }